import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITab from 'UIComponents/nav/UITab';
import UITabBar from 'UIComponents/nav/UITabBar';
import UITabs from 'UIComponents/nav/UITabs';
import { GET_ACTION_SET_CRM_OBJECT_BY_ID } from 'automation-ui-canvas/components/action-set/ActionSetQueries';
import DeleteActionSetModal from 'automation-ui-canvas/components/action-set/DeleteActionSetModal';
import { ALL_ACTIONS_LIST } from 'automation-ui-canvas/constants/AbsolutePaths';
import { parseLocation } from 'automation-ui-routing/utils';
import { useQuery } from 'data-fetching-client';
import { stringify } from 'hub-http/helpers/params';
import get from 'immutable-less/transmute/get';
import getIn from 'immutable-less/transmute/getIn';
import { useState } from 'react';
import { generatePath, useHistory, useLocation, useParams } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ActionSetCanvasTabs = {
  BUILD: 'build',
  SETTINGS: 'settings'
};
const ActionSetCanvasTabBar = () => {
  const history = useHistory();
  const {
    flowId: actionSetId
  } = useParams();
  const location = useLocation();
  const {
    data
  } = useQuery(GET_ACTION_SET_CRM_OBJECT_BY_ID, {
    variables: {
      actionSetId
    }
  });
  const actionSet = get('actionSet', data);
  const name = getIn(['properties', 'hs_name', 'value'], actionSet);
  const createdByUserId = getIn(['properties', 'hs_flow_created_by_user_id', 'value'], actionSet);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleReturnRoutingAfterDelete = () => {
    const flowId = parseLocation(location).sourceFlowId;
    const edgeId = parseLocation(location).sourceEdgeId;
    if (flowId && edgeId) {
      const search = stringify({
        edgeId
      });
      const pathname = generatePath(ALL_ACTIONS_LIST, {
        flowId,
        screen: 'edit'
      });
      history.replace({
        pathname,
        search
      });
    } else {
      history.push('/');
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showDeleteModal && /*#__PURE__*/_jsx(DeleteActionSetModal, {
      actionSetId: actionSetId,
      createdByUserId: createdByUserId,
      name: name,
      onClose: () => setShowDeleteModal(false),
      onSuccess: handleReturnRoutingAfterDelete
    }), /*#__PURE__*/_jsx(UITabBar, {
      bordered: true,
      middleSlot: /*#__PURE__*/_jsxs(UITabs, {
        selected: ActionSetCanvasTabs.BUILD,
        children: [/*#__PURE__*/_jsx(UITab, {
          tabId: ActionSetCanvasTabs.BUILD,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.actionSetCanvas.tabBar.buildTab"
          })
        }), /*#__PURE__*/_jsx(UITab, {
          tabId: ActionSetCanvasTabs.SETTINGS,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.actionSetCanvas.tabBar.settingsTab"
          })
        })]
      }),
      endSlot: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: "tertiary-light",
          size: "xs",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.actionSetCanvas.tabBar.detailsButton"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          disabled: !actionSet,
          use: "tertiary-light",
          size: "xs",
          onClick: () => setShowDeleteModal(true),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.actionSetCanvas.tabBar.deleteButton"
          })
        })]
      })
    })]
  });
};
export default ActionSetCanvasTabBar;